import React from 'react';
import dynamic from 'next/dynamic';
import { Col, Image, Row, Typography } from 'antd';

import classes from './index.module.less';

const Slider = dynamic(() => import('./Slider'), { ssr:false });

const TestimoniContainer = (props: any) => {
	return (
		<div className={classes['page-body-wrap']}>
			<div className="container">
				<Row>
					<Col md={20} sm={20} xs={24} lg={20} xl={20}>
						<div className={classes.headContact}>
							<h2 className={classes.title}>Cerita dari Mama</h2>
							<Typography className={classes.paragraph}>
								Pengalaman asyik dengan Hallobumil dari Mama untuk Mama
							</Typography>
						</div>
					</Col>
					<Col md={4} sm={4} xs={24} lg={4} xl={4}>
						<div className={classes.headkutip}>
							<Image src="/images/default/testimoniheader.svg" alt="kutip" preview={false} />
						</div>
					</Col>
				</Row>
				<Row>
					<Col md={24} sm={24} xs={24} lg={24} xl={24}>
						<Slider {...props} />
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default TestimoniContainer;
